import { createSelector } from 'reselect';
// report-common
import { getReportSelectors } from '../../report-common';
//////////////////////////////////////////////////

const {
  store,
  makeSelectItemList,
  makeSelectUsedReport,
  makeSelectPagination,
  makeSelectTotalCount,
  makeSelectListLoading,
  makeSelectReportStatus,
  makeSelectAvailableReports,
  makeSelectTableTitleFilters,
} = getReportSelectors('chargeReport');


const makeSelectTitleSortValues = () => createSelector(
  store,
  ({ titleSortValues }) => titleSortValues,
);

const makeSelectReportType = () => createSelector(
  store,
  ({ reportType }) => reportType,
);

export {
  makeSelectItemList,
  makeSelectUsedReport,
  makeSelectReportType,
  makeSelectPagination,
  makeSelectTotalCount,
  makeSelectListLoading,
  makeSelectReportStatus,
  makeSelectTitleSortValues,
  makeSelectAvailableReports,
  makeSelectTableTitleFilters,
};
